<template>
  <div class="page-content">
    <section>
      <ListFilter
        class="
          filter-wrap content-wrap
        "
        @filter="filter"
        @change="(value) => (filter = value)"
        @search="() => list(filter)"
      />
    </section>

    <!-- List -->
    <section class="list">
      <div class="content-wrap" style="margin-top: 0">
        <div class="heading">
          <p>
            พบ <b>{{ paging.total }}</b> รายการ
          </p>
          <el-button
            type="primary"
            icon="
              el-icon-circle-plus
            "
            plain
            @click="() => goto('nonsc-project-create')"
          >
            เพิ่มโครงการ
          </el-button>
        </div>
        <div v-if="paging.total > 0" class="content">
          <div class="list">
            <ListItem v-for="(item, i) in items" :key="i" :project="item">
            </ListItem>
          </div>
          <div class="paging">
            <el-pagination
              :background="true"
              :layout="'prev, pager, next'"
              :current-page="paging.page"
              :page-size="paging.limit"
              :total="paging.total"
              @current-change="(page) => (paging.page = page)"
            />
          </div>
        </div>
        <div v-if="paging.total == 0" class="empty">
          <img src="@/assets/images/admin/empty.png" />
          <p>
            <b class="unknown"> ไม่พบข้อมูล </b>
          </p>
        </div>
      </div>
    </section>

    <!-- Loader -->
    <div
      v-loading.fullscreen.lock="loader"
      element-loading-background="rgba(0, 0, 0, 0.4)"
    ></div>
  </div>
</template>

<script lang="js">
// Component
import ListFilter from "./NonScProjectListFilter"
import ListItem from "./NonScProjectListItem"

// Services
// eslint-disable-next-line import/no-cycle
import { NonScFeature } from "../../feature"

export default {
  components: {
    ListFilter,
    ListItem,
  },
  data: () => ({
    loader: false,
    title: "รายการโครงการ",
    paging: {
      page: 1,
      limit: 10,
      total: 0,
    },
    items: [],
    filter: {
      text: "",
      type: "ALL",
    },
  }),
  computed: {
    project() {
      return NonScFeature.project
    },
  },
  watch: {
    "paging.page": function pagingPageWatcher(curr, prev) {
      if (curr !== prev) {
        this.list(this.filter, curr)
      }
    },
    "filter.type": function filterTypeWatcher() {
      this.list(this.filter)
    },
  },
  mounted() {
    // Init Title
    this.$emit("sub-title", this.title)

    // Init List
    this.list(this.filter)
  },
  methods: {
    goto(name) {
      this.$router.push({ name })
    },
    async list(filter, page = 1) {
      // Loading
      this.loader = true

      try {
        // Filter Props
        const { text, type } = filter

        // Pagination Props
        const { limit } = this.paging

        // Filter Params
        const params = {
          text,
          type,
          page,
          limit,
        }

        // Fetch Project
        const { total, items } = await this.project.list(params)

        // Set Items
        this.items = items

        // Set Paging
        Object.assign(this.paging, { page, total })
      } catch ({ message }) {
        // Reset Items
        this.items = []

        // Reset Paging
        Object.assign(this.paging, { page: 1, total: 0 })
      } finally {
        setTimeout(() => {
          this.loader = false
        }, 400)
      }
    },
  },
}
</script>

<style lang="css" scoped>
.content-wrap {
  background-color: white;
}

section.header {
  flex-direction: column;
  padding: var(--size-lg) 0;
}

section.header .content-wrap {
  padding: 0;
  margin: 0 auto;
}

section.list {
  flex-direction: column;
}

section.list .heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--size-lg);
  padding: 0;
}

section.list .content-wrap {
  display: flex;
  flex-direction: column;
  gap: var(--size-md);
  background-color: white;
}

section.list .content,
section.list .list {
  display: flex;
  flex-direction: column;
  gap: var(--size-md);
}

section.list .paging {
  display: flex;
  justify-content: center;
}

.filter-wrap {
  margin-top: var(--size-md);
}

</style>
